import asArray from 'utils/arrays/asArray.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import asObject from 'utils/objects/asObject.util';

export const selectTimeOffAllowances = ($) => $?.timeOff?.allowances ?? asArray();
export const selectTimeOffCategories = ($) => $?.timeOff?.categories ?? asArray();
export const selectTimeOffInitEvent = ($) => $?.timeOff?.init?.event ?? asObject();
export const selectTimeOffMetaIsAllDay = ($) => $?.timeOff?.meta?.isAllDay ?? asObject();
export const selectTimeOffNonce = ($) => fromAnyToString($?.timeOff?.nonce);
export const selectTimeOffReportDto = ($) => $?.timeOff?.report?.dto ?? asObject();
export const selectTimeOffReport = ($) => $?.timeOff?.report?.pvo ?? asObject();
export const selectTimeOffData = ($) => $?.timeOff?.data ?? asObject();
export const selectTimeOffForm = ($) => $?.timeOff?.form ?? asObject();
export const selectTimeOffFormCategory = ($) => $?.timeOff?.form?.category ?? asObject();
